/** Normalize per-question read count from history API rows (supports legacy rows without readCount). */
export function readCountFromHistoryRow(row) {
  if (!row || row.questionId == null) return 0;
  if (row.readCount != null && Number.isFinite(Number(row.readCount))) {
    return Math.max(0, Number(row.readCount));
  }
  return row.readStatus ? 1 : 0;
}

export function buildReadCountMap(historyRows) {
  if (!Array.isArray(historyRows)) return {};
  return historyRows.reduce((acc, row) => {
    if (row?.questionId != null) {
      acc[row.questionId] = readCountFromHistoryRow(row);
    }
    return acc;
  }, {});
}

/** Highest read count first; ties fall back to newer question id. */
export function sortQuestionsByReadCount(items, readCounts) {
  if (!Array.isArray(items) || items.length < 2) return items;
  return [...items].sort((a, b) => {
    const diff = (readCounts[b.id] ?? 0) - (readCounts[a.id] ?? 0);
    if (diff !== 0) return diff;
    return (b.id ?? 0) - (a.id ?? 0);
  });
}

export const LIBRARY_SORT_BY_READS = 'reads_desc';
export const LIBRARY_SORT_DEFAULT = 'default';
